import { render, staticRenderFns } from "./AddRiscossione.vue?vue&type=template&id=5ec6150c&"
import script from "./AddRiscossione.vue?vue&type=script&lang=ts&"
export * from "./AddRiscossione.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports